export const enum StepUpdateAction {
  Add = 'add',
  Replace = 'replace',
  Remove = 'remove',
}
